// noinspection TypeScriptValidateJSTypes

import { FitSelectionOption, inventoryApi } from './inventoryApi';

export const fitSelectionOptions: FitSelectionOption[] = ['Male', 'Female', 'RegularFit', 'SlimFit'];

export const enhancedInventoryApi = inventoryApi.enhanceEndpoints({
    addTagTypes: ["Scanner", "ConfigurationProfile"],
    endpoints: {
        scannersControllerRetrieveScanners: { providesTags: ["Scanner"] },
        scannersControllerRetrieveScanner: { providesTags: ["Scanner"] },
        configurationProfilesControllerRetrieveScannerProfiles: { providesTags: ["Scanner", "ConfigurationProfile"] },
        configurationProfilesControllerRetrieveScannerProfile: { providesTags: ["Scanner", "ConfigurationProfile"] },
        configurationProfilesControllerUpdateScannerProfile: { invalidatesTags: ["ConfigurationProfile"] },
        configurationProfilesControllerUpdateScannerProfileFeatureOverrides: { invalidatesTags: ["ConfigurationProfile"] },
        configurationProfilesControllerUpdateScannerProfileAnalyticsTags: { invalidatesTags: ["ConfigurationProfile"] },
        scannersControllerImportScanners: { invalidatesTags: ["Scanner"] },
        scannersControllerApproveQualityControl: { invalidatesTags: ["Scanner"] },
        scannersControllerUpdateScannerConfiguration: { invalidatesTags: ["Scanner"] },
        scannersControllerDeclineQualityControl: { invalidatesTags: ["Scanner"] },
        scannersControllerUnlinkScanner: { invalidatesTags: ["Scanner"] },
        scannersControllerCancelActivation: { invalidatesTags: ["Scanner"] },
        scannersControllerRetrieveLinkRequest: {
            extraOptions: { qryOptions: { skip404Toast: true } },
        },
        scannersControllerCreateScannerDefect: { invalidatesTags: ["Scanner"] },
        scannersControllerCloseScannerDefect: { invalidatesTags: ["Scanner"] },
        scannersControllerReopenScannerDefect: { invalidatesTags: ["Scanner"] },
    },
});

export const {
    useScannersControllerRetrieveScannerQuery,
    useScannersControllerRetrieveScannersQuery,
    useScannersControllerImportScannersMutation,
    useScannersControllerCreateLinkRequestMutation,
    useScannersControllerRetrieveLinkRequestQuery,
    useScannersControllerApproveQualityControlMutation,
    useLazyScannersControllerRetrieveScannerQuery,
    useConfigurationProfilesControllerUpdateScannerProfileMutation,
    useConfigurationProfilesControllerUpdateScannerProfileAnalyticsTagsMutation,
    useScannersControllerCreateScannerDefectMutation,
    useScannersControllerCloseScannerDefectMutation,
    useScannersControllerReopenScannerDefectMutation,
} = enhancedInventoryApi;
